export function jsonp(url: string): Promise<any> {
  return new Promise((resolve, reject) => {
    const callbackName = 'librivox_callback_' + Math.round(100000 * Math.random());
    
    const timeout = setTimeout(() => {
      cleanup();
      reject(new Error('LibriVox API Timeout'));
    }, 15000);

    const cleanup = () => {
      clearTimeout(timeout);
      const script = document.getElementById(callbackName);
      if (script) document.body.removeChild(script);
      delete (window as any)[callbackName];
    };

    (window as any)[callbackName] = (data: any) => {
      cleanup();
      resolve(data);
    };

    const script = document.createElement('script');
    script.id = callbackName;
    const separator = url.indexOf('?') >= 0 ? '&' : '?';
    script.src = `${url}${separator}callback=${callbackName}`;
    script.onerror = () => {
      cleanup();
      reject(new Error('JSONP request failed'));
    };
    document.body.appendChild(script);
  });
}